import { render } from "./pySelect.vue?vue&type=template&id=72880c4c"
import script from "./pySelect.vue?vue&type=script&lang=js"
export * from "./pySelect.vue?vue&type=script&lang=js"

import exportComponent from "D:\\php\\php20260824_dianshang\\mall-son_dxt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__